import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Empresas de tecnologia com pequeno volume de carga",
    correct: false,
  },
  {
    option: "b) Empresas de transporte público",
    correct: false,
  },
  {
    option: "c) Empresas de qualquer setor com grande fluxo de caminhões",
    correct: true,
  },
  {
    option: "d) Empresas de vajo com foco em vendas online",
    correct: false,
  },
  {
    option:
      "e) Empresas de serviços financeiros com operações logísticas mínimas",
    correct: false,
  },
];

export default function Question14(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question14: {
          title:
            "Quem são os principais clientes-alvo da SAI Smart Logistics em termos de indústria e cargas a serem gerenciadas?",
          option: option.option,
          correct: option.correct,
          order: 14
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quem são os principais clientes-alvo da SAI Smart Logistics em termos de indústria e cargas a serem gerenciadas?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
